// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widgets[data-v-5787b278]{display:flex;flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
